module.exports = __webpack_public_path__ + "img/tips-shower.22813713.svg";